import { c as _c } from "react/compiler-runtime";
import cx from 'classnames';
import { ListItem, List } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { HEIGHT } from '../ContextSwitcher/constants';
import SelectableItem from './SelectableItem';
const useStyles = makeStyles(({
  palette,
  spacing
}) => ({
  root: {
    padding: spacing(1),
    minWidth: 240,
    overflow: 'auto',
    '& +$root': {
      borderTop: `1px solid ${palette.layout.line.divider}`
    }
  },
  childrenItem: {
    width: '100%',
    padding: spacing(1),
    color: 'inherit',
    borderRadius: 4,
    marginTop: 0
  },
  compactContainer: {
    maxHeight: 240
  }
}), {
  classNamePrefix: 'SelectableItemList'
});
export default function SelectableItemList(t0) {
  const $ = _c(25);
  const {
    children: t1,
    listComponent: t2,
    itemComponent: t3,
    items,
    selectedItemValue: t4,
    onChange: t5,
    canClickOnSelected: t6,
    size: t7
  } = t0;
  const children = t1 === undefined ? null : t1;
  const ListComponent = t2 === undefined ? List : t2;
  const ItemComponent = t3 === undefined ? "li" : t3;
  const selectedItemValue = t4 === undefined ? null : t4;
  const onChange = t5 === undefined ? _temp : t5;
  const canClickOnSelected = t6 === undefined ? false : t6;
  const size = t7 === undefined ? HEIGHT.UNSET : t7;
  const classes = useStyles();
  let t8;
  if ($[0] !== onChange) {
    t8 = item => () => {
      onChange(item);
    };
    $[0] = onChange;
    $[1] = t8;
  } else {
    t8 = $[1];
  }
  const getOnItemClick = t8;
  const t9 = size === HEIGHT.COMPACT;
  let t10;
  if ($[2] !== classes.compactContainer || $[3] !== classes.root || $[4] !== t9) {
    t10 = cx(classes.root, {
      [classes.compactContainer]: t9
    });
    $[2] = classes.compactContainer;
    $[3] = classes.root;
    $[4] = t9;
    $[5] = t10;
  } else {
    t10 = $[5];
  }
  let t11;
  if ($[6] !== ItemComponent || $[7] !== canClickOnSelected || $[8] !== getOnItemClick || $[9] !== items || $[10] !== selectedItemValue) {
    let t12;
    if ($[12] !== ItemComponent || $[13] !== canClickOnSelected || $[14] !== getOnItemClick || $[15] !== selectedItemValue) {
      t12 = t13 => {
        const {
          value,
          label: label_0,
          ...otherProps
        } = t13;
        const isSelected = value === selectedItemValue || otherProps.isSelected;
        const listItemProps = isSelected && !canClickOnSelected ? otherProps : {
          onClick: getOnItemClick({
            value,
            label: label_0
          }),
          ...otherProps
        };
        return <SelectableItem key={label_0} label={label_0} isSelected={isSelected} component={ItemComponent} {...listItemProps} />;
      };
      $[12] = ItemComponent;
      $[13] = canClickOnSelected;
      $[14] = getOnItemClick;
      $[15] = selectedItemValue;
      $[16] = t12;
    } else {
      t12 = $[16];
    }
    t11 = items.filter(_temp2).map(t12);
    $[6] = ItemComponent;
    $[7] = canClickOnSelected;
    $[8] = getOnItemClick;
    $[9] = items;
    $[10] = selectedItemValue;
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  let t12;
  if ($[17] !== children || $[18] !== classes.childrenItem) {
    t12 = children && <ListItem className={classes.childrenItem}>{children}</ListItem>;
    $[17] = children;
    $[18] = classes.childrenItem;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] !== ListComponent || $[21] !== t10 || $[22] !== t11 || $[23] !== t12) {
    t13 = <ListComponent className={t10}>{t11}{t12}</ListComponent>;
    $[20] = ListComponent;
    $[21] = t10;
    $[22] = t11;
    $[23] = t12;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  return t13;
}
function _temp2(t0) {
  const {
    label
  } = t0;
  return Boolean(label);
}
function _temp() {}